/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Manager } from './Manager';
import {
    ManagerFromJSON,
    ManagerFromJSONTyped,
    ManagerToJSON,
} from './Manager';

/**
 * 
 * @export
 * @interface ManagerLoginPayload
 */
export interface ManagerLoginPayload {
    /**
     * 
     * @type {boolean}
     * @memberof ManagerLoginPayload
     */
    requires_2fa?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManagerLoginPayload
     */
    token?: string;
    /**
     * 
     * @type {Manager}
     * @memberof ManagerLoginPayload
     */
    user?: Manager;
}

/**
 * Check if a given object implements the ManagerLoginPayload interface.
 */
export function instanceOfManagerLoginPayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ManagerLoginPayloadFromJSON(json: any): ManagerLoginPayload {
    return ManagerLoginPayloadFromJSONTyped(json, false);
}

export function ManagerLoginPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerLoginPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requires_2fa': !exists(json, 'requires_2fa') ? undefined : json['requires_2fa'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'user': !exists(json, 'user') ? undefined : ManagerFromJSON(json['user']),
    };
}

export function ManagerLoginPayloadToJSON(value?: ManagerLoginPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requires_2fa': value.requires_2fa,
        'token': value.token,
        'user': ManagerToJSON(value.user),
    };
}

